import React from 'react'

const DisplayResult = ({
                           state,
                           onIdle,
                           onLoading,
                           onError,
                           onSuccess,
                           onEmpty
                       }) => {
    return (

        <div style={{textAlign: 'center'}}>
            {state.isLoading() && onLoading && onLoading()}
            {state.isError() && onError && onError(state.getErrorMessage())}
            {state.isSuccess() && onSuccess && onSuccess(state.getSuccessData())}
            {state.isEmpty() && onEmpty && onEmpty()}
            {state.state === 'Idle' && onIdle && onIdle()}
        </div>

    )
}

export default DisplayResult


// WEBPACK FOOTER //
// ./src/util/DisplayResult.js